/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { forwardRef } from "react";
import { useI18n } from "intl/useI18n";
import { cn } from "tailwind-variants";
import "./JiffyPromotionTransfers.scss";
import JiffyTransfersInlineIcon from "assets/icons/jiffy-transfers-inline.svg";

const JiffyPromotionTransfers = forwardRef<HTMLAnchorElement, any>(
  ({ creditValue, spendThreshold, openInNewTab = true, ...restProps }, ref) => {
    const { n } = useI18n();

    function isMobileApp() {
      // @ts-expect-error TS(2339): Property 'MOBILE_APP' does not exist on type 'Wind... Remove this comment to see the full error message
      return Boolean(window.MOBILE_APP);
    }

    function openInSameTab() {
      return isMobileApp() || !openInNewTab;
    }

    return (
      <a
        {...restProps}
        ref={ref}
        className={cn(
          "jiffy-promotion-transfers js-jiffy-promotion scope-d5d4a7d9",
          // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
          restProps.className
        )}
        href="/transfers"
        target={openInSameTab() ? "_self" : "_blank"}
        rel={openInSameTab() ? undefined : "noreferrer"}
        data-mixpanel-listen="click"
        data-mixpanel-event="crosssell_cta_transfers_credits_offer_click"
        data-mixpanel-data={JSON.stringify({
          page: "cart",
          business_line_promo_type: "Transfers",
          promotion_name: `spend_${spendThreshold}_get_store_credit`
        })}
        data-testid="jiffy-promotion-transfers"
      >
        <div className="jiffy-promotion-transfers__store-credit-wrapper scope-d5d4a7d9">
          <span className="jiffy-promotion-transfers__store-credit-value scope-d5d4a7d9">
            {n(creditValue, "currencyNoCents")}
          </span>
          <span className="scope-d5d4a7d9">STORE CREDIT</span>
        </div>
        <div className="jiffy-promotion-transfers__info-wrapper scope-d5d4a7d9">
          <div className="jiffy-promotion-transfers__info scope-d5d4a7d9">
            <JiffyTransfersInlineIcon
              className="jiffy-promotion-transfers__logo-icon scope-d5d4a7d9"
              data-testid="jiffy-promotion-transfers-logo-icon"
            />
            <p className="jiffy-promotion-transfers__info-text scope-d5d4a7d9">
              {" "}
              New to JiffyTransfers? Spend {n(spendThreshold, "currencyNoCents")}+ on blank apparel,{" "}
              <strong className="scope-d5d4a7d9">
                {" "}
                get {n(creditValue, "currencyNoCents")} in store credit to try it out!{" "}
              </strong>
            </p>
          </div>
        </div>
      </a>
    );
  }
);

JiffyPromotionTransfers.displayName = "JiffyPromotionTransfers";

export default JiffyPromotionTransfers;
